module.exports = __webpack_public_path__ + "static/YouTube-8-7327137f56a52bb8d9646a033ff3cad3.png";